import { getAllCriteria } from '@/features/AudienceManager/services';
export const fetchAllCriteria = (mode) => {
    return getAllCriteria().then(response => {
        return formatCriteria(response?.data, mode);
    });
};
const formatCriteria = (response, mode) => {
    const rawData = response?.data ?? {};
    const success = response?.success;
    const errors = response?.errors ?? [];
    const filteredData = mode === 'create' ? filterEnabledOnly(rawData) : rawData;
    return {
        data: formatCriteriaOptions(filteredData),
        errors,
        success,
    };
};
const filterEnabledOnly = (data) => {
    const result = Object.entries(data)
        .map(([categoryKey, categoryValue]) => {
        const enabledCriteria = Object.entries(categoryValue).filter(([, criteria]) => criteria.enabled);
        return [categoryKey, Object.fromEntries(enabledCriteria)];
    })
        .filter(([, value]) => Object.keys(value).length > 0);
    return Object.fromEntries(result);
};
const formatCriteriaOptions = (data) => {
    return Object.entries(data).map(([categoryKey, categoryValue]) => ({
        key: categoryKey,
        columns: Object.entries(categoryValue).map(([criteriaKey, details]) => ({
            key: criteriaKey,
            name: details.name,
            type: details.type,
            format: details.format,
            enabled: details.enabled,
            multiple: details.multiple ?? false,
            autocomplete: details.autocomplete ?? false,
            options: details.options,
            operators: details.operators,
            filter: details?.filter
                ? {
                    name: details.filter.name,
                    type: details.filter.type,
                    f_type: details.filter.f_type,
                    format: details.filter.format,
                    options: details.filter.options,
                    operators: details.filter.operators,
                    autocomplete: details.filter.autocomplete ?? false,
                    multiple: details.filter.multiple ?? false,
                }
                : null,
        })),
    }));
};
